var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "#3ACA2E",
    strokeOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2056_5344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.3751C14.5711 14.3751 16.25 12.6962 16.25 10.6251C16.25 8.55405 14.5711 6.87512 12.5 6.87512C10.4289 6.87512 8.75 8.55405 8.75 10.6251C8.75 12.6962 10.4289 14.3751 12.5 14.3751Z",
    stroke: "#3ACA2E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81592 17.6558C7.39222 16.6583 8.22089 15.83 9.21866 15.2541C10.2164 14.6783 11.3482 14.3751 12.5002 14.3751C13.6523 14.3751 14.784 14.6783 15.7818 15.2542C16.7795 15.8301 17.6082 16.6584 18.1845 17.6559",
    stroke: "#3ACA2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2056_5344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(5 5.00012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.0bb5011bc131a548286e3320e789f44d.svg";
export { ForwardRef as ReactComponent };